export default {
  priv: 'pr_reference',
  overviewTitle: 'Adressen',
  detailTitle: 'Adres',
  deleteTitle: 'dit adres',
  url: '/references/addresses',
  apiUrl: '/addresses/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'addresses',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  newRecord: {
    contract_emt: false
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/addresses/{id}',
      width: '27.5%'
    },
    {
      text: 'Adres',
      value: 'address',
      width: '30%'
    },
    {
      text: 'Postcode',
      value: 'pc',
      align: 'center',
      width: '10%'
    },
    {
      text: 'Plaats',
      value: 'city',
      width: '12.5%'
    },
    {
      text: 'Land',
      value: 'country',
      width: '10%'
    }
  ]
};
